<template>
  <div :id="echarts" ref="doubleBarChart" class="container" />
</template>

<script>
import * as echarts from "echarts";
import { EleResize } from "@/utils/eleResize";

export default {
  name: "doubleBarChart",
  props: {
    // 接收父组件传递过来的信息
    xData: {
      type: Array,
      default: () => [],
    },
    dataL: {
      type: Array,
      default: () => [],
    },
    dataR: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  computed: {
    echarts() {
      return "echarts" + Math.random() * 100000;
    },
  },
  mounted: function () {
    const vm = this;
    vm.$nextTick(() => {
      vm.drawChart();
    });
  },
  created: () => {},
  methods: {
    drawChart() {
      var myChart = echarts.init(document.getElementById(this.echarts));
      var option = {
        timeline: {
          show: false,
          top: 0,
          data: [],
        },
        tooltip: {
          show: true,
        },
        // title: {
        //   text: "",
        //   textStyle: {
        //     color: "#FFFFFF",
        //     fontWeight: "800",
        //     fontSize: "20",
        //   },
        //   left: "center",
        //   top: "2%",
        // },
        legend: {
          show: true,
          top: "0%",
          textStyle: {
            color: "rgba(179, 185, 187, 1)",
          },
          data: ["雨水管", "污水管"],
        },
        grid: [
          // 左边柱子
          {
            show: false,
            left: "10%",
            top: "10%",
            bottom: "20",
            containLabel: true,
            width: "33%",
          },
          // 中间
          {
            show: false,
            left: "51%",
            top: "10%",
            bottom: "38",
            width: "0%",
          },
          // 右边柱子
          {
            show: false,
            right: "10%",
            top: "10%",
            bottom: "20",
            containLabel: true,
            width: "33%",
          },
        ],
        xAxis: [
          {
            name: "单位：万公里",
            nameTextStyle: {
              lineHeight: 30, //标题行高
              padding: [-20, -50, 0, 0],
              verticalAlign: "top",
              color: "#fff ",
            },
            type: "value",
            inverse: true,
            min: 0,
            max: 5,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#fff ",
            },
            splitLine: {
              show: false,
            },
          },
          {
            gridIndex: 1,
            show: false,
          },
          {
            name: "单位：万公里",
            nameTextStyle: {
              lineHeight: 30, //标题行高
              padding: [-20, 0, 0, -55],
              verticalAlign: "top",
              color: "#fff ",
            },
            min: 0,
            max: 25,
            gridIndex: 2,
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              color: "#fff ",
            },
            splitLine: {
              show: false,
            },
          },
        ],
        yAxis: [
          {
            type: "category",
            inverse: true,
            position: "right",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            data: this.xData,
          },
          {
            gridIndex: 1,
            type: "category",
            inverse: true,
            position: "center",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: true,
              align: "center",
              color: "#CDD7D7",
              fontSize: 14,
            },

            data: this.xData,
          },
          {
            gridIndex: 2,
            type: "category",
            inverse: true,
            position: "left",
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              show: false,
            },
            data: this.xData,
          },
        ],
        series: [
          {
            name: "雨水管",
            type: "bar",
            xAxisIndex: 0,
            yAxisIndex: 0,
            barWidth: 15,
            showBackground: false,
            itemStyle: {
              borderRadius: 0,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: "#F9DD46",
                },
                {
                  offset: 1,
                  color: "#F29740",
                },
              ]),
            },
            label: {
              show: true,
              position: "left",
              color: "#fff",
            },
            data: this.dataL,
          },
          {
            name: "污水管",
            type: "bar",
            xAxisIndex: 2,
            yAxisIndex: 2,
            barWidth: 15,
            showBackground: false,
            itemStyle: {
              borderRadius: 0,
              color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [
                {
                  offset: 0,
                  color: "#3A6ECD",
                },
                {
                  offset: 1,
                  color: "#4BE6E6",
                },
              ]),
            },
            label: {
              show: true,
              position: "right",
              color: "#fff",
            },
            data: this.dataR,
          },
        ],
      };
      option && myChart.setOption(option);
      const listener = function () {
        myChart.resize();
      };
      EleResize.on(document.getElementById(this.echarts), listener);
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100%;
}
</style>
